<script setup lang="ts">
/**
 * @author Alexander Kenchoshvili
 */

//

import { SecondaryDataInterface } from "@/types/ContentType";
import { Swiper, SwiperSlide } from "swiper/vue";
import { swiperOptions } from "./ts/swiper";
import "swiper/css";
import type { NavigationOptions, Swiper as SwiperInterface } from "swiper/types";
import { Navigation } from "swiper";
import { ref, computed } from "vue";
import { useRoute } from "vue-router";

import { useMainStore } from "@/store/main/index";
import NewsCard from "../NewsList/parts/NewsCard.vue";
import LongLeftArrow from "@/components/regularComponents/UIComponents/SVG/actions/LongLeftArrow.vue";
import LongRightArrow from "@/components/regularComponents/UIComponents/SVG/actions/LongRightArrow.vue";

const props = defineProps<{
  contentData: SecondaryDataInterface | undefined;
}>();

const mainStore = useMainStore();
const title = props?.contentData?.conf?.header?.title;

const singleRoute = useRoute().params?.slugs?.[1] as string;
const splittedId = mainStore.getSingleDataIdFromUrl(singleRoute);
const swiperRef = ref<SwiperInterface>();

const simiallarData = computed(() => props?.contentData?.data?.list);
const simillarNewsData = computed(() => {
  return simiallarData.value?.filter((item) => item.id !== splittedId);
});

const onSwiper = (swiper: SwiperInterface) => {
  swiperRef.value = swiper;
};

const navOptions: NavigationOptions = {
  enabled: true,
  prevEl: ".simillar-news__navigation-left",
  nextEl: ".simillar-news__navigation-right",
};
</script>

<template>
  <div class="simillar-news">
    <div class="container">
      <div class="simillar-news__items">
        <div class="simillar-news__header d-flex j-btw al-center">
          <h2 class="simillar-news__title pos-rel uppercase hl-2-light">
            {{ title }}
          </h2>
          <div class="simillar-news__navigation"  v-show="swiperRef?.allowSlideNext || swiperRef?.allowSlidePrev">
            <LongLeftArrow  class="simillar-news__navigation-left" />
            <LongRightArrow  class="simillar-news__navigation-right" />
          </div>
        </div>
        <Swiper
          v-if="simillarNewsData?.length"
          :watchOverflow="true"
          @swiper="onSwiper"
          :grab-cursor="true"
          :slides-per-view="swiperOptions.slidesPerView"
          :space-between="swiperOptions.spaceBetween"
          :breakpoints="swiperOptions.breakpoints"
          :options="swiperOptions"
          :navigation="navOptions"
          :modules="[Navigation]"
          :key="mainStore?.windowWidth"

        >
          <SwiperSlide v-for="(simillarData, index) in simillarNewsData" :key="index">
            <NewsCard :data="simillarData" />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.simillar-news {
  position: relative;
  .swiper-button-disabled{
    opacity: 0.4;
  }
  &__header {
    padding: 0px 24px;
    margin-bottom: 41px;
  }
  &__navigation {
    @include maxq(mobile){
      position: absolute;
    bottom: -60px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    }
    &-left,
    &-right{
      cursor: pointer;
      @include easeOut(700ms,all)
    }
    &-left{
      @include hover{
        transform: translateX(-10px);
      }
    }
    &-right{
     @include hover{
      transform: translateX(10px);
     }
    }
  }
  &__title {
    font-size: 32px;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: -25px;
      width: 2px;
      height: 100%;
      background-color: $mango;
    }
  }

}
</style>
